import { render, staticRenderFns } from "./SubmenuPictureView.vue?vue&type=template&id=9cd1fb3e&scoped=true"
import script from "./SubmenuPictureView.vue?vue&type=script&lang=js"
export * from "./SubmenuPictureView.vue?vue&type=script&lang=js"
import style0 from "./SubmenuPictureView.vue?vue&type=style&index=0&id=9cd1fb3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd1fb3e",
  null
  
)

export default component.exports